module.exports = __webpack_public_path__ + "img/precintes-seguretat.8d223e6c.jpg";